import {
    Dialog,
    Toast
} from 'vant';

//公共帮助
var Common = {
    //Toast轻提示
    toast: function(msg, type) {
        if(type == 'success'){
            Toast.success(msg);
        } else if(type == 'fail'){
            Toast.fail(msg);
        } else {
            Toast(msg);
        }
    },

    //加载
    showLoading: function(msg) {
        Toast.loading({
            mask: true,
            message: msg,
            duration: 0,
        });
    },

    //清除加载弹窗
    clearLoading: function() {
        Toast.clear();
    },

    // 提示弹窗
    showMsg: function(msg, callback, title, isboth) {
        if (title == null || title.length == 0) {
            title = isboth ? (localStorage.getItem("lang") || "zh") === 'zh' ? "提示" : "Prompt" : "提示";
        }
        Dialog.alert({
            title: title,
            message: msg,
            confirmButtonText: isboth ? (localStorage.getItem("lang") || "zh") === 'zh' ? "确认" : "Confirm" : "确认"
        }).then(() => {
            typeof callback === "function" ? callback() : false;
        });
    },

    // 确认弹窗
    confirmDialog: function(msg, comfirmCallback, cancelCallback, title) {
        if (title == null || title.length == 0) {
            title = "提示";
        }
        Dialog.confirm({
            title: title,
            message: msg,
            confirmButtonText: "确认",
            cancelButtonText: "取消"
        }).then(() => {
            typeof comfirmCallback === "function" ? comfirmCallback() : false;
        }).catch(() => {
            typeof cancelCallback === "function" ? cancelCallback() : false;
        });
    },

    //解析富文本值
    escape2Html(str) {
        var arrEntities = {
            lt: "<",
            gt: ">",
            nbsp: " ",
            amp: "&",
            quot: '"'
        };
        return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
            return arrEntities[t];
        });
    },

    //转化
    ToText(HTML) {
        var input = HTML;
        return input
            .replace(/<(style|script|iframe)[^>]*?>[\s\S]+?<\/\1\s*>/gi, "")
            .replace(/<[^>]+?>/g, "")
            .replace(/\s+/g, " ")
            .replace(/ /g, " ")
            .replace(/>/g, " ");
    },

    //手机端
    _isMobile() {
        let flag = navigator.userAgent.match(
            /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
    },


    //字符超过长度用...表示
    getStr(content, lengthSize) {
        var j = 0;
        for (var i = 0; i < content.length; i++) {
            //判断是不是有中文
            if (content.charCodeAt(i) >= 0 && content.charCodeAt(i) <= 255) {
                j += 1;
            } else {
                j += 2; //中文，相当于占两位字符
            }
            if (j >= lengthSize) { //如果占的位数超过了最大显示的位数
                return content.substring(0, i + 1) + "...";
            }
        }
        return content; //如果占的位数没有超过最大显示的位数
    }

}
export default Common